import React from "react";
import { FaEye, FaBullseye, FaQuoteLeft, FaCheckCircle, FaArrowRight,FaHeart ,FaHandsHelping} from "react-icons/fa";

const VisionMissionSection = () => {
  return (
    <section className="py-16 px-4 bg-gradient-to-br from-slate-50 via-white to-slate-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-100 text-blue-700 text-sm font-semibold">
              <FaEye className="text-lg" />
              Our Guiding Principles
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-blue-700 to-green-600 bg-clip-text text-transparent">
              Vision & Mission
            </span>
          </h2>
          
          <p className="text-gray-600 text-lg max-w-3xl mx-auto leading-relaxed">
            Our vision and mission drive everything we do at R.D.S. NURSING & PARAMEDICAL COLLEGE, 
            guiding us toward excellence in healthcare education.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="group bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 overflow-hidden border border-gray-100">
            <div className="h-2 bg-gradient-to-r from-blue-600 to-blue-500"></div>
            <div className="p-8">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <FaEye className="text-4xl text-blue-600" />
                </div>
                <h2 className="text-3xl font-bold text-gray-800">Our Vision</h2>
              </div>
              <div className="relative mb-6">
                <FaQuoteLeft className="text-5xl text-blue-200 absolute -top-4 -left-2" />
                <p className="text-gray-700 text-lg leading-relaxed pl-12 pr-4 italic font-medium relative z-10">
                  To be a globally recognized center of excellence in nursing and pharmaceutical education, 
                  producing compassionate healthcare professionals who lead with integrity, innovation, 
                  and dedication to serve humanity.
                </p>
              </div>
              <div className="grid grid-cols-2 gap-4 mt-8">
                <div className="bg-blue-50 p-4 rounded-xl text-center">
                  <p className="text-2xl font-bold text-blue-600">2028</p>
                  <p className="text-xs text-gray-600">Center of Excellence</p>
                </div>
                <div className="bg-blue-50 p-4 rounded-xl text-center">
                  <p className="text-2xl font-bold text-blue-600">Global</p>
                  <p className="text-xs text-gray-600">Recognition</p>
                </div>
              </div>

              <div className="mt-6 flex items-center justify-end">
                <button className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium text-sm">
                  Read More <FaArrowRight className="text-xs" />
                </button>
              </div>
            </div>
          </div>
          <div className="group bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 overflow-hidden border border-gray-100">
            <div className="h-2 bg-gradient-to-r from-green-600 to-green-500"></div>
            <div className="p-8">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <FaBullseye className="text-4xl text-green-600" />
                </div>
                <h2 className="text-3xl font-bold text-gray-800">Our Mission</h2>
              </div>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                    <FaCheckCircle className="text-green-600 text-sm" />
                  </div>
                  <span className="text-gray-700">Provide quality education through modern curriculum and experienced faculty</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                    <FaCheckCircle className="text-green-600 text-sm" />
                  </div>
                  <span className="text-gray-700">Develop skilled healthcare professionals through practical training in leading hospitals</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                    <FaCheckCircle className="text-green-600 text-sm" />
                  </div>
                  <span className="text-gray-700">Foster research and innovation in pharmaceutical and nursing sciences</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                    <FaCheckCircle className="text-green-600 text-sm" />
                  </div>
                  <span className="text-gray-700">Serve the community through healthcare awareness programs and medical camps</span>
                </li>
              </ul>
              <div className="mt-8 bg-gradient-to-r from-green-50 to-blue-50 p-4 rounded-xl">
                <p className="text-base font-medium text-gray-700 text-center italic">
                  "Shaping the future of healthcare education since 1998"
                </p>
              </div>
              <div className="mt-6 flex items-center justify-end">
                <button className="inline-flex items-center gap-2 text-green-600 hover:text-green-700 font-medium text-sm">
                  Read More <FaArrowRight className="text-xs" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="bg-white rounded-xl p-4 shadow-md text-center">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2">
              <FaHeart className="text-blue-600 text-xl" />
            </div>
            <p className="font-semibold text-gray-800">Compassion</p>
          </div>
          <div className="bg-white rounded-xl p-4 shadow-md text-center">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2">
              <FaHandsHelping className="text-green-600 text-xl" />
            </div>
            <p className="font-semibold text-gray-800">Service</p>
          </div>
          <div className="bg-white rounded-xl p-4 shadow-md text-center">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2">
              <FaBullseye className="text-blue-600 text-xl" />
            </div>
            <p className="font-semibold text-gray-800">Excellence</p>
          </div>
          <div className="bg-white rounded-xl p-4 shadow-md text-center">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2">
              <FaEye className="text-green-600 text-xl" />
            </div>
            <p className="font-semibold text-gray-800">Integrity</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMissionSection;